import React, { useId, useState } from 'react';
import { ChevronRight } from 'lucide-react';
import T from 'Components/Helpers/translate';

/**
 * WEB-11466 - the brief a background run was started with, folded away.
 *
 * When a chat turn runs out of wall clock it hands the rest of the job to a
 * background run and writes it a brief: what is done, what is left, which files
 * to read. `emitConversationRun` seeds it as the child conversation's first
 * message and `saveMessage` stores it with `role: 'user'`, so the person who
 * opens the thread reads it in their own bubble having never written a word of
 * it. The model still needs it - the child sees no history - so it stays a real
 * message and only its rendering changes.
 */

/** True for the seeded first message of a delegated run. `emitConversationRun` is the only
 *  thing that writes `metadata.delegation`, so a message the person typed never matches. */
export const isHandoffSeed = (metadata: unknown): boolean =>
	!!(metadata as { delegation?: unknown } | undefined)?.delegation;

const HandoffSeedMessage = ({ content }: { content: string }) => {
	const [open, setOpen] = useState(false);
	const bodyId = useId();

	return (
		<div className="ws-handoff-seed">
			<button
				type="button"
				className="ws-handoff-seed-toggle"
				aria-expanded={open}
				aria-controls={bodyId}
				onClick={() => setOpen(v => !v)}
			>
				<ChevronRight
					aria-hidden
					style={{
						width: 13,
						height: 13,
						flexShrink: 0,
						transition: 'transform 120ms',
						transform: open ? 'rotate(90deg)' : undefined
					}}
				/>
				<span>{T('assistant.handoffSeed.label')}</span>
			</button>
			{open && (
				<div id={bodyId} className="ws-handoff-seed-body">
					{content}
				</div>
			)}
		</div>
	);
};

export default HandoffSeedMessage;
